import { Logo } from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL } from "../lib/content";

export const Footer = () => (
  <footer data-testid="footer" className="relative overflow-hidden bg-navy-deep pt-16 pb-8">
    <div className="noise-overlay" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid gap-10 border-b border-white/10 pb-12 md:grid-cols-3">
        <div>
          <Logo dark className="h-14 w-auto lg:h-16" />
          <p className="mt-5 font-display text-lg font-bold text-white">
            Delivering Excellence Across Metro Atlanta
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/60">
            Secure, professional same-day courier services for medical, legal, and business clients across Metro Atlanta.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Contact</p>
          <div className="mt-5 space-y-3 text-sm text-white/70">
            <a href={`tel:${PHONE_TEL}`} className="block transition-colors hover:text-white" data-testid="footer-phone">{PHONE_DISPLAY}</a>
            <a href={`mailto:${EMAIL}`} className="block transition-colors hover:text-white" data-testid="footer-email">{EMAIL}</a>
            <p>Decatur, Georgia</p>
            <p>Serving Metro Atlanta</p>
          </div>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Services</p>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            <li>Medical Courier</li>
            <li>Legal Courier</li>
            <li>Business Courier</li>
            <li>Scheduled Routes</li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-3 pt-8 text-sm text-white/50 sm:flex-row">
        <p>Serving Metro Atlanta</p>
        <p>Copyright © 2026 Wilson Courier Solutions</p>
      </div>
    </div>
  </footer>
);
